import type { DuplicateReviewSummary } from '@/hooks/usePatientMerge'

type Signals = DuplicateReviewSummary['signals'][number]

const SIGNAL_LABELS: { key: keyof Signals; label: string }[] = [
  { key: 'activeAccount', label: 'Active account' },
  { key: 'completedEncounter', label: 'BeHuman encounter' },
  { key: 'identityVerified', label: 'Verified identity' },
  { key: 'signedConsent', label: 'Signed consent' },
]

/** The indicators the keep-record recommendation weighs, for one record. */
export function ReviewSignals({ signals }: { signals: Signals }) {
  const present = SIGNAL_LABELS.filter(({ key }) => signals[key])
  if (present.length === 0) {
    return <span className="text-[13px] text-[#6B7280] italic">No signals</span>
  }
  return (
    <ul className="m-0 flex list-none flex-wrap gap-1.5 p-0" aria-label="Review signals">
      {present.map(({ key, label }) => (
        <li
          key={key}
          className="inline-flex h-6 items-center rounded-full bg-[#F1F2F4] px-2.5 text-[12px] font-semibold text-[#4A5160]"
        >
          {label}
        </li>
      ))}
    </ul>
  )
}
